export const publicUrl: string = process.env.REACT_APP_CORDOVA_BUILD! ? './' : '/';
export const os: string = process.env.REACT_APP_CORDOVA_BUILD! ? process.env.REACT_APP_CORDOVA_OS! : 'web';
